// @flow

const DATETIME_FORMAT = 'MM-DD-YYYY HH:mm Z'

export { DATETIME_FORMAT }
